import React from 'react';
import 'youtube-video-js';


export default function VideoDialog({ onClose, open, windowWidth, videoLink }) {

  const handleClose = value => {
    onClose(value);
  };

  let w = "1024";
  let h = "600";

  if (windowWidth <= 1024 && windowWidth >= 900) {
    w = "800";
    h = "340";
  } else if (windowWidth <= 900 && windowWidth >= 768) {
    w = "540";
    h = "240";
  } else if (windowWidth <= 768) {
    w = "400";
    h = "200";
  }

  return (
    <div onClick={handleClose} 
      className={open ? "popup-container": "popup-container-hiden"}>
      {/* <youtube-video
        width={w}
        height={h}
        src="https://www.youtube.com/watch?v=Wn9twYUXw6w"
        // autoplay
        controls
      /> */}
      <iframe width={w} height={h} frameBorder="0"
        src={`https://www.youtube.com/embed/${videoLink}`}>
      </iframe>
    </div>
  );
}
